/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import LoadingSpinner from 'DesignSystem/LoadingSpinner/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Insurances/Insurance/Subscription/Content/Content/Search/Loading"
  
}) {
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<div
  data-testid="Loading.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-2mx3jB': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Vertical}`}
>
<LoadingSpinner
  viewPath={`${viewPath}/LoadingSpinner`}
 delay={0}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral400}
 text="Searching for insurance plans..."
/>
</div>
{children}
</React.Fragment>)
}